// src/app/directives/no-special-chars.directive.ts
import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[noSpecialChars]'
})
export class NoSpecialCharsDirective {

  @Input() allowedRegex: string = '^[\\u00C0-\\u017F\\w\\s{}\\(\\]\\-_.,@()]+$';
  @Input() errorMessageKey: string = 'Please_enter_a_valid_file_name'; 

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    let value = input.value || '';

    const invalidPattern = new RegExp(`[^\\u00C0-\\u017F\\w\\s{}\\(\\]\\-_.,@()]`, 'g');

    const invalidCharsFound = value.match(invalidPattern);

    if (invalidCharsFound) {
      // Remove all invalid characters instantly
      const cleanValue = value.replace(invalidPattern, '');
      input.value = cleanValue;

      this.ngControl.control?.setValue(cleanValue, { emitEvent: false });

      this.ngControl.control?.setErrors({ invalidChars: true });
    } else {
      const currentErrors = this.ngControl.control?.errors;
      if (currentErrors?.['invalidChars']) {
        const { invalidChars, ...rest } = currentErrors;
        this.ngControl.control?.setErrors(Object.keys(rest).length ? rest : null);
      }
    }
    this.ngControl.control?.updateValueAndValidity({ emitEvent: true });
  }
@HostListener('paste', ['$event'])
onPaste(event: ClipboardEvent): void {
  // Let the browser paste first, then clean immediately
  setTimeout(() => {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const invalidPattern = new RegExp(`[^\\u00C0-\\u017Fa-zA-Z0-9\\s_\\-.,@()]`, 'g');
    const hasInvalid = invalidPattern.test(value);

    if (hasInvalid) {
      const cleanValue = value.replace(invalidPattern, '');
      input.value = cleanValue;
      this.ngControl.control?.setValue(cleanValue, { emitEvent: false });

      // THIS IS THE KEY LINE
      this.ngControl.control?.markAsTouched();   // ← forces appFieldError to show
      this.ngControl.control?.setErrors({ invalidChars: true });
    } else {
      this.ngControl.control?.markAsTouched();
      // clear previous invalidChars error if exists
      const err = this.ngControl.control?.errors;
      if (err?.['invalidChars']) {
        delete err['invalidChars'];
        this.ngControl.control?.setErrors(Object.keys(err).length ? err : null);
      }
    }
  }, 0);
}
}
